import { useUserActiveOrganization, useRemovePaymentConnection } from "@/api";
import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { toast } from "@/components/ui/use-toast";
import { DialogClose } from "@radix-ui/react-dialog";
import { CircleX } from "lucide-react";
import { useState } from "react";

const RemovePaymentPlatfromConnection = () => {
  const [isConfirmRemovePaymentOpen, setIsConfirmRemovePaymentOpen] =
    useState(false);
  const { activeOrganization } = useUserActiveOrganization();
  const [removePaymentConnection] = useRemovePaymentConnection();

  const removePaymentConnectionHandler = async () => {
    try {
      if (!activeOrganization) return;

      const { data } = await removePaymentConnection({
        variables: {
          organizationSlug: activeOrganization.slug
        }
      });

      if (
        data?.paymentAccountDelete.__typename ===
        "PaymentAccountHasActiveSubscriptions"
      ) {
        setIsConfirmRemovePaymentOpen(false);
        toast({
          title: "Active subscriptions",
          description: "Cannot remove an account with active subscriptions."
        });
        return;
      }

      if (data?.paymentAccountDelete.__typename === "PaymentAccountNotFound") {
        setIsConfirmRemovePaymentOpen(false);
        toast({
          title: "Account not found",
          description:
            "The payment account was not found, please try again or report the issue."
        });
        return;
      }

      setIsConfirmRemovePaymentOpen(false);
      toast({
        title: "Payment account removed",
        description: "The payment account was removed from the organization."
      });
    } catch (error) {
      toast({
        title: "Remove payment failed",
        description:
          "Failed to remove payment connection, please try again or report the issue."
      });
      console.error("An error occurred:", error);
    }
  };
  return (
    <span
      className="w-fit flex"
      onClick={(e) => {
        e.stopPropagation();
      }}
      role="button"
      tabIndex={0}
      aria-label="Remove payment connection"
    >
      <Dialog.Root
        open={isConfirmRemovePaymentOpen}
        onOpenChange={setIsConfirmRemovePaymentOpen}
      >
        <Dialog.Trigger asChild>
          <Button variant="outline" className="hover:text-brand-error">
            Remove
            <CircleX size={15} className="ml-4" />
          </Button>
        </Dialog.Trigger>

        <Dialog.Content className="max-w-lg dark:bg-brand-gray-900">
          <Dialog.Header className="space-y-2 relative">
            <Dialog.Title className="leading-5 text-brand-gray-800 dark:text-brand-gray-100 ">
              Remove revenue connection
            </Dialog.Title>
            <Dialog.Description className="text-brand-gray-700 dark:text-brand-gray-300">
              Are you sure you want to remove the revenue connection from this
              organization?
            </Dialog.Description>
          </Dialog.Header>

          <Dialog.Footer className="mt-8">
            <DialogClose asChild>
              <Button type="button" variant="secondary">
                Cancel
              </Button>
            </DialogClose>
            <Button
              type="button"
              variant="destructive"
              onClick={removePaymentConnectionHandler}
            >
              Remove
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Root>
    </span>
  );
};

export default RemovePaymentPlatfromConnection;
